// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9f25bbdc","453":"b73dd566","455":"afe59968","977":"acbf5b0b"}[chunkId] + ".chunk.js";
};